__turbopack_context__.v({
  "Provider": "game-card-module__uAUlyW__Provider",
  "ProviderSm": "game-card-module__uAUlyW__ProviderSm",
  "Title": "game-card-module__uAUlyW__Title",
  "TitleSm": "game-card-module__uAUlyW__TitleSm",
});
